import React from 'react';
import styles from './styles.scss';

interface CheckmarkProps {
  id: string;
  value: boolean;
  name: string;
  label: string;
}

const Checkmark: React.FC<CheckmarkProps> = ({ id, label, name, value: checked, ...props }) => (
  <div role="button" className={styles.checkmark}>
    <input id={id} name={name} type="checkbox" className="hide" checked={checked} {...props} />
    <label htmlFor={id}>
      <div className={styles.checkmarkLabel}>{label}</div>
    </label>
  </div>
);

export default Checkmark;
